import {spu} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const FormRow = styled.div<{marginTopSpuMultiplier?: number}>`
  margin-top: calc(
    ${spu} *
      ${({marginTopSpuMultiplier}) =>
        marginTopSpuMultiplier ? marginTopSpuMultiplier : 3.5}
  );
  display: flex;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;
`;

export const EditRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Description = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
  margin-top: 20px;
`;
Description.displayName = 'S.Description';
